export const Wellness = () => (
  <svg width="61" height="61">
    <defs>
      <path id="a" d="M0 .607h60.358V60.29H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(0 .103)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M30.18 2.213c-7.631 0-14.806 2.938-20.203 8.27-11.138 11.01-11.138 28.923 0 39.932 5.397 5.333 12.572 8.27 20.202 8.27 7.63 0 14.805-2.937 20.202-8.27 11.138-11.009 11.138-28.923 0-39.933-5.397-5.331-12.572-8.27-20.202-8.27m0 58.079c-8.065 0-15.648-3.105-21.35-8.74-11.772-11.637-11.772-30.568 0-42.204C14.531 3.711 22.114.607 30.18.607c8.066 0 15.648 3.104 21.35 8.74 11.772 11.636 11.772 30.567 0 42.203-5.702 5.636-13.284 8.741-21.35 8.741"
          fill="#FFF"
          mask="url(#b)"
        />
      </g>
      <path
        d="M34.058 19.178a3.796 3.796 0 0 0-1.138-2.708 3.888 3.888 0 0 0-2.741-1.125c-1.07 0-2.039.43-2.74 1.125a3.796 3.796 0 0 0-1.138 2.708m0 22.746a3.8 3.8 0 0 0 1.137 2.71 3.889 3.889 0 0 0 2.74 1.123c1.07 0 2.04-.43 2.742-1.123a3.8 3.8 0 0 0 1.138-2.71"
        stroke="#FFF"
        strokeWidth="2"
      />
      <path
        d="M26.3 19.178v7.54h-7.627c-1.07 0-2.04.43-2.742 1.124a3.798 3.798 0 0 0 0 5.419 3.89 3.89 0 0 0 2.742 1.123H26.3v7.54m7.757 0v-7.54h7.628c1.069 0 2.038-.43 2.741-1.123a3.8 3.8 0 0 0 0-5.42 3.889 3.889 0 0 0-2.741-1.123h-7.628v-7.54"
        stroke="#FFF"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export default Wellness;
